// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3cXTB","col":"styles_col__bEdno"};